/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import LogicContext from "../../Context/LogicContext";
import { SetStockList, GetStockList } from "../../store/stockAtom";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { stockService } from "../../services/stockService";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

// To improve the look, we'll use Tailwind CSS classes for better styling, responsiveness, and modern UI.
// Assuming Tailwind is set up in the project. If not, it can be added via CDN or installation.
// Removed unused imports and optimized code for clarity.

const StockViewMainPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext);

  const setStockData = SetStockList();
  const getStockData = GetStockList();
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [searchText, setSearchText] = useState("");

  // Memoized columns
  const columns = useMemo(
    () => [
      {
        title: "Product Id",
        key: "item_id",
        dataIndex: "item_id",
        className: "text-blue-600 font-medium",
        sorter: (a, b) => (a?.item_id ?? "").localeCompare(b?.item_id ?? ""),
      },
      {
        title: "No.",
        dataIndex: "item_sku",
        sorter: (a, b) => (a?.item_sku ?? "").localeCompare(b?.item_sku ?? ""),
      },
      {
        title: "Product Name",
        dataIndex: "item_name",
        sorter: (a, b) => (a?.item_name ?? "").localeCompare(b?.item_name ?? ""),
      },
      {
        title: "Category",
        dataIndex: "item_group_name",
        sorter: (a, b) => (a?.item_group_name ?? "").localeCompare(b?.item_group_name ?? ""),
      },
      {
        title: "Commited Order Stock",
        dataIndex: "committed_order_quantity",
        sorter: (a, b) => (a?.committed_order_quantity ?? "") - (b?.committed_order_quantity ?? ""),
            render: record => <span> {formatCustomNumber(record)} </span>,
        
      },
      {
        title: "Accounting Stock",
        dataIndex: "accounting_quantity",
        sorter: (a, b) => (a?.accounting_quantity ?? "") - (b?.accounting_quantity ?? ""),
        render: record => <span> {formatCustomNumber(record)} </span>,

      },
      {
        title: "Purchased Transit Stock",
        dataIndex: "purchase_transit_quantity",
        sorter: (a, b) => (a?.purchase_transit_quantity ?? "") - (b?.purchase_transit_quantity ?? ""),
        render: record => <span> {formatCustomNumber(record)} </span>,

      },
      {
        title: "Physical Stock",
        dataIndex: "physical_stock_quantity",
        sorter: (a, b) => (a?.physical_stock_quantity ?? "") - (b?.physical_stock_quantity ?? ""),
        render: record => <span> {formatCustomNumber(record)} </span>,

      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    if (getStockData?.stock_info?.length > 0) {
      setTableData(getStockData?.stock_info);
    } else {
      getStockListFromAPI();
    }
    return () => {
    };
  }, []);

  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getStockListFromAPI();
    }
  }, []);

  // Fetch stock list
  const getStockListFromAPI = useCallback(async () => {
    try {
      const response = await stockService.stockViewList();
      if (response?.data !== undefined) {
        setStockData(response.data);
      setTableData(response.data?.stock_info || []);

      }
    } catch (err) {
      console.error(err);
    }
  }, [setStockData]);




  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);



  const handleRowClick = useCallback(
    (data) => {
      const id = data["item_id"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );

  const onClearInput = () => {
    setSearchText("");
    setTableData(getStockData?.stock_info || []);
  };

  const handleSearch = (text) => {
    setSearchText(text);
    if (text.trim() === "") {
      setTableData(getStockData?.stock_info || []);
      return;
    }
    const searchTerm = text.toLowerCase();
    const filtered = (getStockData?.stock_info || []).filter((item) =>
      Object.values(item).some((value) => value?.toString().toLowerCase().includes(searchTerm))
    );
    setTableData(filtered);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 space-y-4 md:space-y-0">
        <h2 className="text-2xl font-bold text-gray-800">Stock View</h2>
        <div className="flex items-center space-x-4">
          {/* Refresh Button */}
          <button
            onClick={getStockListFromAPI}
            className="p-2 rounded-full  shadow-md hover:bg-gray-100 transition-colors"
            title="Refresh"
          >
            {/* <IoMdRefresh className="h-5 w-5 text-gray-600" /> */}
            <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />



          </button>
          {/* Add New Button */}
          {/* <button
            onClick={addNewInvoice}
            className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition-colors flex items-center space-x-2"
          >
            <FaPlus className="h-4 w-4" />
            <span className="text-white" >Add New</span>
          </button> */}
        </div>
      </div>

      {/* Search Input */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search in table..."
          value={searchText}
          onKeyDown={(e) => {
            if (e.key === "Backspace" && searchText === "") {
              onClearInput();
            }
          }}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
        />
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.item_id} // Updated to use item_id as key
          handleRowClick={handleRowClick}
        />
      </div>
    </div>
  );
};

export default React.memo(StockViewMainPage);